import { MaintenanceVehicleValues } from "./maintenance-vehicle-values.model";

export interface MaintenanceVehicle {
  vehicle: string;
  values: MaintenanceVehicleValues[];
}